<template>
  <a-modal
    :visible="visible"
    :width="960"
    :bodyStyle="{ height: '560px' }"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    centered
  >
    <template slot="title">
      <div style="display: flex">
        <span style="font-size: 18px; font-weight: 800; margin-right: 24px">团队分配</span>
        <div class="frontSite">（共筛选出</div>
        <div class="frontSite" style="color: #1991ff">{{ total }}</div>
        <div class="frontSite">个站点）</div>
      </div>
    </template>
    <a-form-model :layout="layout" :model="form" :rules="rules">
      <a-form-model-item label="重要程度配置" prop="name">
        <a-select allowClear v-model="form.degreeImport" style="width: 100%">
          <a-select-option :value="1"> 一般</a-select-option>
          <a-select-option :value="2"> 重要</a-select-option>
          <a-select-option :value="3">非常重要 </a-select-option>
          <a-select-option :value="0">未知 </a-select-option>
        </a-select>
      </a-form-model-item>
      <div>监控配置</div>
      <a-row style="margin-top: 15px" :gutter="30">
        <a-col :span="12" style="">
          <a-form-model-item label="" prop="juese">
            保持控制：{{ open ? '开' : '关' }}
            <a-switch size="small" v-model="open" @change="handleChange" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12" style="padding-top: 3px" v-if="open">
          <a-form-model-item label="" prop="monitorHz">
            <div style="display: flex">
              <div style="width: 22%">监控天数：</div>
              <a-input style="width: 75%" v-model="form.monitorHz" addon-after="天">
                <!-- <a-select slot="addonAfter" default-value="day" style="width: 80px">
                  <a-select-option value="day"> 天/次 </a-select-option>
                </a-select> -->
              </a-input>
            </div>
          </a-form-model-item>
        </a-col>
      </a-row>
      <div v-if="open">
        <div>解析率告警阈值配置</div>
        <a-row :gutter="30" style="margin-top: 20px">
          <a-col :span="12" style="">
            <a-form-model-item label="">
              标题解析率 <=
              <a-input style="width: 75%" v-model="form.titleResolutionFactor" addon-after="%">
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="">
              时间解析率 <=
              <a-input style="width: 75%" v-model="form.timeResolutionFactor" addon-after="%">
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" style="padding-top: 3px">
            <a-form-model-item label="">
              正文解析率 <=
              <a-input style="width: 75%" v-model="form.contentResolutionFactor" addon-after="%">
              </a-input>
            </a-form-model-item>
            <a-form-model-item label="">
              文件解析率 <=
              <a-input style="width: 75%" v-model="form.fileResolutionFactor" addon-after="%">
              </a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
  </a-modal>
</template>

<script>
import { detail, allot } from '@/api/Monitor/abnormal'
export default {
  props: {
    selectedRowKeys: {
      default: []
    },
    total: { default: '' }
  },
  data() {
    return {
      confirmLoading: false,
      open: true,
      visible: false,
      layout: 'horizontal',
      form: {
        juese: undefined,
        name: undefined,
        people: undefined
      },
      PL: undefined,
      rules: {
        // name: [{ required: true, message: '请输入用户名称', trigger: 'blur' }],
        // juese: [{ required: true, message: '请输入角色类型', trigger: 'blur' }]
        // people: [{ required: true, message: '请选择用户组成员', trigger: 'blur' }]
      }
    }
  },
  methods: {
    showModelForPL() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.info('请选择站点')
      } else {
        this.PL = true
        this.open = true
        this.form = {
          monitorStatus: 0,
          degreeImport: undefined,
          monitorHz: undefined,
          titleResolutionFactor: undefined,
          contentResolutionFactor: undefined,
          timeResolutionFactor: undefined,
          fileResolutionFactor: undefined
        }
        this.visible = true
      }
    },
    showModel(record) {
      this.form = {}
      this.PL = false
      this.visible = true
      if (record.monitorStatus === 1) {
        this.open = false
      } else {
        this.open = true
      }
      let {
        monitorStatus,
        degreeImport,
        monitorHz,
        titleResolutionFactor,
        contentResolutionFactor,
        timeResolutionFactor,
        fileResolutionFactor
      } = record
      this.form = {
        monitorStatus,
        degreeImport,
        monitorHz,
        titleResolutionFactor,
        contentResolutionFactor,
        timeResolutionFactor,
        fileResolutionFactor
      }
      this.record = record
    },
    handleChange() {
      if (this.open) {
        if (this.record.monitorStatus === 1) {
          this.form.monitorStatus = 0
        } else {
          this.form.monitorStatus = this.record.monitorStatus
        }
      } else {
        this.form.monitorStatus = 1
      }
    },
    handleOk(e) {
      this.confirmLoading = true
      let param = { ...this.form }
      if (this.PL) {
        param.idList = [...this.selectedRowKeys]
      } else {
        param.idList = [this.record.id]
      }

      if (this.open === false) {
        delete param.monitorHz
        delete param.titleResolutionFactor
        delete param.contentResolutionFactor
        delete param.timeResolutionFactor
        delete param.fileResolutionFactor
        param.monitorStatus = 1
      } else {
        if (param.monitorStatus === 1) {
          param.monitorStatus = 0
        }
        for (let i in param) {
          if (typeof param[i] === 'string') {
            if (param[i] === '') {
              this.$message.error('请输入' + this.checkWich(i))
              this.confirmLoading = false
              return false
            } else {
              var y = String(param[i]).indexOf('.') + 1
              if (y > 0) {
                this.$message.error(this.checkWich(i) + '请输入整数')
                this.confirmLoading = false
                return false
              } else {
                if (isNaN(param[i])) {
                  this.$message.error(this.checkWich(i) + '请输入数字')
                  this.confirmLoading = false
                  return false
                } else {
                  param[i] = Number(param[i])
                }
              }
            }
          }
        }
        if (param.monitorHz > 30 || param.monitorHz < 0) {
          this.$message.error('监控频率不能大于30天，且不能小于0天')
          this.confirmLoading = false
          return false
        }
        if (param.titleResolutionFactor > 100 || param.titleResolutionFactor < 0) {
          this.$message.error('标题解析率不能大于100%，且不能小于0%')
          this.confirmLoading = false
          return false
        }
        if (param.contentResolutionFactor > 100 || param.contentResolutionFactor < 0) {
          this.$message.error('正文解析率 不能大于100%，且不能小于0%')
          this.confirmLoading = false
          return false
        }
        if (param.timeResolutionFactor > 100 || param.timeResolutionFactor < 0) {
          this.$message.error('时间解析率不能大于100%，且不能小于0%')
          this.confirmLoading = false
          return false
        }
        if (param.fileResolutionFactor > 100 || param.fileResolutionFactor < 0) {
          this.$message.error('文件解析率不能大于100%，且不能小于0%')
          this.confirmLoading = false
          return false
        }
      }

      detail({ ...param, monitorUnit: 'day' }).then((res) => {
        if (res.code === 200) {
          this.$message.success(res.msg)
          this.visible = false
          this.$emit('reload')
        } else {
          this.$message.error(res.msg)
        }

        this.confirmLoading = false
      })
      // setTimeout(() => {
      //   this.visible = false
      //   this.confirmLoading = false
      // }, 2000)
    },
    checkWich(key) {
      switch (key) {
        case 'monitorHz':
          return '监控频率'
        case 'titleResolutionFactor':
          return '标题解析率'
        case 'contentResolutionFactor':
          return '正文解析率'
        case 'timeResolutionFactor':
          return '时间解析率'
        case 'fileResolutionFactor':
          return '文件解析率'

        default:
          break
      }
    },
    handleCancel(e) {
      this.visible = false
    }
  }
}
</script>
<style lang="less" scoped>
.frontSite {
  font-size: 18px;
  font-weight: 400;
  color: #595959;
}
</style>
<style></style>
